module.exports = __webpack_public_path__ + "static/media/home-slide-1.7f467359.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MainImage/home-slide-1.jpg
// module id = 336
// module chunks = 0